export default "__VITE_ASSET__RDytKR2n__"